module.exports = __webpack_public_path__ + "static/media/shops.4743aca2.svg";